import { Model } from '@vuex-orm/core'

export default class Contact extends Model {
  static entity = 'contacts'

  static primaryKey = ['project_id', 'type']

  static fields () {
    return {
      type: this.string('site'),
      project_id: this.string(''),
      name: this.string(''),
      street: this.string(''),
      zip: this.string(''),
      city: this.string(''),
      email: this.string(''),
      phone: this.string('')
    }
  }

  get isBlank () {
    // measure total lengrh of important values (Exclude ids & type)
    return Object.keys(this)
      .reduce((a, c) => a + (!/^(\$id|id|type|project_id)$/i.test(c)
        ? this[c].trim().length 
        : 0), 0
      ) === 0
  }
}



// WEBPACK FOOTER //
// ./src/store/models/Contact.js